/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed`)
};

const es_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad`)
};

const de_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschwindigkeit`)
};

const nl_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snelheid`)
};

const fr_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse`)
};

const it_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità`)
};

const pt_br2_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade`)
};

const pt_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade`)
};

const ja_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速度`)
};

const zh_uc_cat_speed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速度`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_speed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_speed(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_speed", locale)
	if (locale === "en") return en_uc_cat_speed(inputs)
	if (locale === "es") return es_uc_cat_speed(inputs)
	if (locale === "de") return de_uc_cat_speed(inputs)
	if (locale === "nl") return nl_uc_cat_speed(inputs)
	if (locale === "fr") return fr_uc_cat_speed(inputs)
	if (locale === "it") return it_uc_cat_speed(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_speed(inputs)
	if (locale === "pt") return pt_uc_cat_speed(inputs)
	if (locale === "ja") return ja_uc_cat_speed(inputs)
	return zh_uc_cat_speed(inputs)
};